import React, { useEffect, useRef, useState } from 'react';
import { useFileUploader } from 'hooks/useFileUploader';
import data from '@emoji-mart/data';
import { ICONS } from '../../../../../../assets/icons';
import Picker from '@emoji-mart/react';
import { useSelector } from 'react-redux';
import ButtonGX from '../../../../../channels/page/webChat/ButtonGX';

import { SendOutlined } from '@ant-design/icons';
import moment from 'moment';
const ChatBoxFooter = ({ className, onSend }) => {
  // selectors
  const { currentBrand } = useSelector((state) => state?.app);
  const { selectedWebChatConversation, selectedWebChatTeam } = useSelector(
    (state) => state?.inbox,
  );
  const { connection_details } = selectedWebChatConversation;
  // const isEndUserOnline = connection_details?.last_active_at
  //   ? moment(connection_details?.last_active_at)
  //       .utc()
  //       .isAfter(moment().utc().subtract(3, 'minutes'))
  //   : false;
  const isEndUserOnline = connection_details?.is_online;

  // hooks
  const { uploading, selectedFile, uploadFiles } = useFileUploader();

  // states
  const [inputMessage, setInputMessage] = React.useState('');
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);

  // refs
  const fileInputRef = useRef();

  // handlers
  // Handle file input change
  const handleFileChange = async (e) => {
    // You can pass format and data as needed, here using 'DOCUMENT' as default
    await uploadFiles(e, 'DOCUMENT');
    // Optionally, you can send the file or show a preview here
  };

  // Handle emoji select
  const handleEmojiSelect = (emoji) => {
    setInputMessage((prev) => prev + emoji.native);
    setShowEmojiPicker(false);
  };

  // Handle file icon click
  const handleFileIconClick = () => {
    if (fileInputRef.current) fileInputRef.current.click();
  };

  const handleInputKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  // Send message handler
  const handleSend = () => {
    if (!inputMessage.trim()) return;
    if (!selectedWebChatConversation?.id) {
      console.warn('conv id required');
      return;
    }
    const params = {
      type: 'chat',
      content: inputMessage,
      conversation_id: Number(selectedWebChatConversation?.id),
      brand_id: String(currentBrand?.brand_id),
      sender_id: String(selectedWebChatTeam?.team_member_id),
      team_id: String(selectedWebChatTeam?.team_id),
      sender_type: 'system_user',
    };
    // const message = JSON.stringify(params);
    onSend(params);
    setInputMessage('');
  };

  const isConversationAssignedToMe =
    selectedWebChatConversation?.details?.assigned_team_member?.id ==
    selectedWebChatTeam?.team_member_id;
  console.log({
    selectedWebChatConversation:
      selectedWebChatConversation?.details?.assigned_team_member?.id,
    selectedWebChatTeam: selectedWebChatTeam?.team_member_id,
  });

  useEffect(() => {
    if (!selectedWebChatConversation) return;
    if (!isConversationAssignedToMe) {
      setInputMessage('');
    }
  }, [selectedWebChatConversation]);

  return (
    <div
      className={`bg-white shadow-md p-10 m-10 b-radius-6  flex  gap-2 items-center relative ${className}`}
    >
      <div className="w-100 flex-col rounded-[4px]">
        {console.log({
          selectedWebChatConversation:
            selectedWebChatConversation.agent_engagement_status,
          isConversationAssignedToMe,
          isEndUserOnline,
        })}
        <textarea
          disabled={
            selectedWebChatConversation.agent_engagement_status ||
            !isConversationAssignedToMe ||
            !isEndUserOnline
          }
          placeholder="Type your message..."
          className="w-full  h-[10vh] px-2 py-1 pr-20 rounded-md  focus:outline-none  resize-none min-h-[40px] max-h-40 overflow-y-auto"
          value={inputMessage}
          onChange={(e) => setInputMessage(e.target.value)}
          onKeyDown={handleInputKeyDown}
          rows={1}
          style={{ resize: 'none' }}
        />
        <div className="flex-row space-between gap-2 items-center z-10">
          <div>
            <button
              type="button"
              className="p-1 hover:bg-gray-100 rounded"
              onClick={() => setShowEmojiPicker((v) => !v)}
              tabIndex={-1}
            >
              <img src={ICONS.step3EmojiIcon} alt="emoji" className="w-5 h-5" />
            </button>
            {/* <button
              type="button"
              className="p-1 hover:bg-gray-100 rounded"
              onClick={handleFileIconClick}
              tabIndex={-1}
            >
              <img
                src={ICONS?.Attachments}
                alt=""
                className="size-[1.3vw] ml-5"
              />
            </button> */}
            {/* <input
              type="file"
              ref={fileInputRef}
              style={{ display: 'none' }}
              onChange={handleFileChange}
            /> */}
          </div>

          <ButtonGX
            disabled={
              !inputMessage.trim() ||
              !isConversationAssignedToMe ||
              !isEndUserOnline
            }
            iconPosition="end"
            icon={<SendOutlined />}
            loading={buttonLoading}
            size="large"
            onClick={handleSend}
          >
            Send
          </ButtonGX>
        </div>
        {/* Emoji Picker Popover */}
        {showEmojiPicker && (
          <div className="absolute bottom-12 right-0 z-50">
            <Picker
              data={data}
              onEmojiSelect={handleEmojiSelect}
              theme="light"
            />
          </div>
        )}
      </div>

      {uploading && (
        <span className="text-xs text-blue-500 ml-2">Uploading...</span>
      )}
      {selectedFile && !uploading && (
        <span className="text-xs text-green-600 ml-2">{selectedFile.name}</span>
      )}
    </div>
  );
};

export default ChatBoxFooter;
